/**
 * Shared helpers for the document-list panels (Clinical References + Embedded Documents).
 */

export const docMatchesPrompt = (doc, normalizedPromptId) => {
  if (!normalizedPromptId) return false;
  const ids = [
    ...(Array.isArray(doc.promptIds) ? doc.promptIds : []),
    ...(doc.promptId ? [doc.promptId] : []),
  ];
  return ids.some(
    (id) => String(id).trim().toLowerCase() === normalizedPromptId,
  );
};

/**
 * Mirror of the server-side sanitizeFileName (functions/src/chartmind/_shared/files.js),
 * so client-side pending placeholders can be matched against persisted docs whose
 * names were sanitized on upload.
 */
export const sanitizeFileName = (fileName) =>
  String(fileName || "")
    .split(/[\\/]/)
    .pop()
    .replace(/[^\w.-]+/g, "_");

/** Numeric-aware alphabetical comparator for document lists. */
export const compareByFileName = (a, b) =>
  String(a?.fileName || "").localeCompare(String(b?.fileName || ""), undefined, {
    numeric: true,
    sensitivity: "base",
  });

/**
 * Drop pending placeholders whose uploaded counterpart has already arrived via the
 * live snapshot (matched by sanitized file name), so a document never shows twice
 * mid-batch.
 */
export const hidePendingDuplicates = (pending, persisted) => {
  const persistedNames = new Set(
    persisted.map((doc) => sanitizeFileName(doc.fileName)),
  );
  return pending.filter(
    (entry) => !persistedNames.has(sanitizeFileName(entry.fileName)),
  );
};
